export default "__VITE_ASSET__BO_T91NO__"